export default __webpack_public_path__ + "static/media/jhope.d1072bbd.GIF";